import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class Urls {

    public static urls = {
        health: environment.apiUrlBase + "health",
        login: environment.apiUrlBase + "users/login",
        logout: environment.apiUrlBase + "users/logout",
        companies: environment.apiUrlBase + "companies",
        company: environment.apiUrlBase + "companies",
        companyTariffs: environment.apiUrlBase + "companies/tariffs",
        companyTaxes: environment.apiUrlBase + "companies/taxes",
        companyIban: environment.apiUrlBase + "companies/iban",
        companyImap: environment.apiUrlBase + "companies/imap",
        users: environment.apiUrlBase + "users",
        roles: environment.apiUrlBase + "roles",
        panels: environment.apiUrlBase + "panels",
        clients: environment.apiUrlBase + "clients",
        providers: environment.apiUrlBase + "providers",
        categories: environment.apiUrlBase + "categories",
        products: environment.apiUrlBase + "products",
        productsStockReport: environment.apiUrlBase + "products/stock-report",
        measurements: environment.apiUrlBase + "measurements",
        productTypes: environment.apiUrlBase + "product-types",
        offices: environment.apiUrlBase + "offices",
        pay_methods: environment.apiUrlBase + "pay-methods",
        documents: environment.apiUrlBase + "documents",
        purchases: environment.apiUrlBase + "purchases",
        tickets: environment.apiUrlBase + "tickets",
        tables: environment.apiUrlBase + "tables",
        cashClosings: environment.apiUrlBase + "cash-closings",
        cashClosingsPreview: environment.apiUrlBase + "cash-closings/preview",
        selectors: environment.apiUrlBase + "selectors",
        specialClients: environment.apiUrlBase + "companies/special-clients",
        templatesSettings: environment.apiUrlBase + "templates-settings",
        historyInventory: environment.apiUrlBase + "history-inventory",
        activityLogs: environment.apiUrlBase + "activity-logs",
        dashboard: environment.apiUrlBase + "dashboard",
        documentsPendingVerifactu: environment.apiUrlBase + "documents/pending-verifactu",
        documentsSendVerifactu: environment.apiUrlBase + "documents/send-to-verifactu",
        documentsConvertToBudget: environment.apiUrlBase + "documents/convert-to-budget",
        companyVerifactuCert: environment.apiUrlBase + "companies/verifactu-cert",
        companyVerifactuAutoSend: environment.apiUrlBase + "companies/verifactu-auto-send",
        verifactuInvoices: environment.apiUrlBase + "verifactu/invoices",
        tablets: environment.apiUrlBase + "tablets",
        tabletsPair: environment.apiUrlBase + "tablets/pair",
        tabletsPairingCode: environment.apiUrlBase + "tablets/pairing-code",
        documentDeviceHeartbeat: environment.apiUrlBase + "document-device/heartbeat",
        backupsRun: environment.apiUrlBase + "backups/run",
        integrations: environment.apiUrlBase + "integrations",
    }

}